// assets/nd-cart-shipping-fields.js
// Address Book (dropdown + Save/Delete) + Shipping block + Clear Shipping button

(function () {
  if (window.__ND_CART_SHIPPING_FIELDS_TOP_CENTER_V6_AB__) return;
  window.__ND_CART_SHIPPING_FIELDS_TOP_CENTER_V6_AB__ = true;

  // ---------- UI font sizes ----------
  var TITLE_FONT_SIZE = "1.8rem";  // "Shipping Information"
  var LABEL_FONT_SIZE = "1.5rem";  // field labels
  var INPUT_FONT_SIZE = "1.5rem";  // input / textarea text

  // ---------- Address Book API config ----------
  var ADDRESS_API_URL = "https://script.google.com/macros/s/AKfycbxvyDwrs28Q7BCYbCiqmysFjSYJ-wH1AbL6dnSowfADscVv9vhSTpu_6BoOBshDD5Ea/exec";
  var ADDRESS_API_KEY = "NeumaAddressBook";

  // ---------- Helpers ----------

  function getCartForm() {
    return (
      document.querySelector('form[action="/cart"]') ||
      document.querySelector('form[action*="/cart"]')
    );
  }

  function getCustomerEmail() {
    var body = document.body || document.querySelector("body");
    if (!body) return "";
    var ds = body.dataset || {};
    return String(
      ds.customerEmail || body.getAttribute("data-customer-email") || ""
    ).toLowerCase();
  }

  // ---------- Build Address Book row + Shipping block ----------

  function buildAddressBookAndShippingBlock() {
    var attrs =
      (window.Shopify && Shopify.cart && Shopify.cart.attributes) || {};

    function esc(v) {
      return v ? String(v).replace(/</g, "&lt;").replace(/>/g, "&gt;") : "";
    }

    var inputStyle =
      "width:100%;" +
      "margin-bottom:10px;" +
      "border-radius:6px;" +
      "border:0.8px solid rgb(153,153,153);" +
      "padding:8px 10px;" +
      "font-size:" + INPUT_FONT_SIZE + ";" +
      "box-shadow:none;" +
      "background-color:transparent;";

    var textareaStyle =
      "width:100%;" +
      "margin-bottom:10px;" +
      "border-radius:6px;" +
      "border:0.8px solid rgb(153,153,153);" +
      "padding:8px 10px;" +
      "font-size:" + INPUT_FONT_SIZE + ";" +
      "box-shadow:none;" +
      "background-color:transparent;" +
      "resize:vertical;";

    var container = document.createElement("div");
    container.id = "nd-cart-shipping-fields";
    container.style.maxWidth = "720px";
    container.style.margin = "24px auto 24px";
    container.style.boxSizing = "border-box";

    container.innerHTML =
      // ===== Address Book row =====
      '<div id="nd-address-book-block" style="margin-bottom:22px;">' +
      '  <div style="display:flex;flex-wrap:wrap;align-items:flex-end;gap:16px;">' +
      '    <div style="flex:1 1 260px;min-width:260px;">' +
      '      <label style="display:block;margin-bottom:4px;font-size:' +
      TITLE_FONT_SIZE +
      ';font-weight:600;font-family:"Alegreya Sans",system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;">Address Book</label>' +
      '      <select id="nd-ab-select" style="' +
      "width:100%;padding:8px 10px;border-radius:6px;border:0.8px solid rgb(153,153,153);" +
      "font-size:" + INPUT_FONT_SIZE +
      ';background-color:transparent;">' +
      '        <option value="">-- Select saved info --</option>' +
      "      </select>" +
      "    </div>" +
      '    <div style="display:flex;flex-wrap:wrap;gap:8px;">' +
      '      <button type="button" id="nd-ab-save" style="min-width:140px;padding:10px 18px;border-radius:6px;border:1px solid rgb(153,153,153);' +
      "font-size:" + INPUT_FONT_SIZE +
      ';cursor:pointer;background:transparent;">Save Address</button>' +
      '      <button type="button" id="nd-ab-delete" style="min-width:140px;padding:10px 18px;border-radius:6px;border:1px solid #b00020;' +
      "font-size:" + INPUT_FONT_SIZE +
      ';cursor:pointer;background:transparent;color:#b00020;">Delete Address</button>' +
      '      <button type="button" id="nd-ab-clear" style="min-width:160px;padding:10px 18px;border-radius:6px;border:1px solid rgb(153,153,153);' +
      "font-size:" + INPUT_FONT_SIZE +
      ';cursor:pointer;background:transparent;">Clear Shipping Info</button>' +
      "    </div>" +
      "  </div>" +
      '  <div id="nd-ab-msg" style="margin-top:6px;font-size:0.8rem;color:#666;"></div>' +
      "</div>" +
      // ===== Shipping fields =====
      '<h3 style="margin:0 0 10px 0;font-size:' +
      TITLE_FONT_SIZE +
      ';font-weight:600;font-family:"Alegreya Sans",system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;">Shipping Information</h3>' +
      // row 1
      '<div style="display:flex;flex-wrap:wrap;gap:16px;margin-bottom:6px;">' +
      '  <div style="flex:1 1 0;min-width:160px;">' +
      '    <label style="display:block;margin-bottom:4px;font-size:' +
      LABEL_FONT_SIZE +
      ';">Contact Name</label>' +
      '    <input type="text" name="attributes[Shipping Contact Name]" ' +
      '           style="' + inputStyle + '" value="' +
      esc(attrs["Shipping Contact Name"]) + '">' +
      "  </div>" +
      '  <div style="flex:1 1 0;min-width:160px;">' +
      '    <label style="display:block;margin-bottom:4px;font-size:' +
      LABEL_FONT_SIZE +
      ';">Phone Number</label>' +
      '    <input type="text" name="attributes[Shipping Phone]" ' +
      '           style="' + inputStyle + '" value="' +
      esc(attrs["Shipping Phone"]) + '">' +
      "  </div>" +
      '  <div style="flex:1 1 0;min-width:160px;">' +
      '    <label style="display:block;margin-bottom:4px;font-size:' +
      LABEL_FONT_SIZE +
      ';">Reference Number</label>' +
      '    <input type="text" name="attributes[Reference Number]" ' +
      '           style="' + inputStyle + '" value="' +
      esc(attrs["Reference Number"]) + '">' +
      "  </div>" +
      "</div>" +
      // row 2: company
      '<label style="display:block;margin-bottom:4px;font-size:' +
      LABEL_FONT_SIZE +
      ';">Company Name (optional)</label>' +
      '<input type="text" name="attributes[Company Name]" ' +
      '       style="' + inputStyle + '" value="' +
      esc(attrs["Company Name"]) + '">' +
      // row 3: address
      '<label style="display:block;margin-bottom:4px;font-size:' +
      LABEL_FONT_SIZE +
      ';">Shipping Address</label>' +
      '<textarea name="attributes[Shipping Address]" rows="2" ' +
      '          style="' + inputStyle + '">' +
      esc(attrs["Shipping Address"]) + "</textarea>";

    return container;
  }

  // ---------- Address Book wiring ----------

  function setupAddressBook(root) {
    if (!root) return;

    var customerEmail = getCustomerEmail();
    var apiUrl = ADDRESS_API_URL;
    var apiKey = ADDRESS_API_KEY;

    var selectEl  = root.querySelector("#nd-ab-select");
    var btnSave   = root.querySelector("#nd-ab-save");
    var btnDelete = root.querySelector("#nd-ab-delete");
    var btnClear  = root.querySelector("#nd-ab-clear");
    var msgEl     = root.querySelector("#nd-ab-msg");

    if (!selectEl || !btnSave || !btnDelete || !btnClear || !msgEl) {
      console.warn("[ND AB] required elements not found, abort.");
      return;
    }

    function setMsg(text, isError) {
      msgEl.textContent = text || "";
      msgEl.style.color = isError ? "#b00020" : "#666";
    }

    function buildQuery(params) {
      var parts = [];
      for (var k in params) {
        if (!Object.prototype.hasOwnProperty.call(params, k)) continue;
        parts.push(encodeURIComponent(k) + "=" + encodeURIComponent(params[k]));
      }
      return parts.join("&");
    }

    function fetchJSON(params) {
      var url = apiUrl + "?" + buildQuery(params);
      return fetch(url, { method: "GET", redirect: "follow" }).then(function (res) {
        return res.json();
      });
    }

    var itemsCache = [];

    function applyAddress(item) {
      if (!item) return;

      console.log("[ND AB] applyAddress item =", item);

      // Always re-query fields in case DOM was rebuilt
      var fContactNow = root.querySelector('input[name="attributes[Shipping Contact Name]"]');
      var fPhoneNow   = root.querySelector('input[name="attributes[Shipping Phone]"]');
      var fRefNow     = root.querySelector('input[name="attributes[Reference Number]"]');
      var fCompanyNow = root.querySelector('input[name="attributes[Company Name]"]');
      var fAddressNow = root.querySelector('textarea[name="attributes[Shipping Address]"]');

      var contact = item.contact_name || item.contact || "";
      var phone   = item.phone_number || item.phone || "";
      // Reference Number 不存到 Address Book，所以不從 item 讀
      var company = item.company_name || item.company || "";
      var address = item.shipping_address || item.shipping_addres || item.address || "";

      if (fContactNow) fContactNow.value = contact;
      if (fPhoneNow)   fPhoneNow.value   = phone;
      if (fCompanyNow) fCompanyNow.value = company;
      if (fAddressNow) fAddressNow.value = address;
      // Reference Number 保留使用者當前輸入，不覆蓋
    }

    function clearShippingFields() {
      var fContactNow = root.querySelector('input[name="attributes[Shipping Contact Name]"]');
      var fPhoneNow   = root.querySelector('input[name="attributes[Shipping Phone]"]');
      var fRefNow     = root.querySelector('input[name="attributes[Reference Number]"]');
      var fCompanyNow = root.querySelector('input[name="attributes[Company Name]"]');
      var fAddressNow = root.querySelector('textarea[name="attributes[Shipping Address]"]');

      if (fContactNow) fContactNow.value = "";
      if (fPhoneNow)   fPhoneNow.value   = "";
      if (fRefNow)     fRefNow.value     = "";
      if (fCompanyNow) fCompanyNow.value = "";
      if (fAddressNow) fAddressNow.value = "";

      setMsg("Shipping info cleared.", false);
    }

    function reloadList() {
      if (!customerEmail) {
        selectEl.disabled  = true;
        btnSave.disabled   = true;
        btnDelete.disabled = true;
        btnClear.disabled  = true;
        setMsg("Please sign in to use Address Book.", false);
        return;
      }
      if (!apiUrl || !apiKey) {
        setMsg("Address Book API is not configured.", true);
        return;
      }

      selectEl.disabled  = false;
      btnSave.disabled   = false;
      btnDelete.disabled = false;
      btnClear.disabled  = false;

      setMsg("Loading saved addresses...", false);

      fetchJSON({
        action: "listAddressBook",
        key: apiKey,
        customer_email: customerEmail
      })
        .then(function (data) {
          console.log("[ND AB] listAddressBook data =", data);

          if (!data || data.ok === false) {
            var err = (data && data.error) ? data.error : "Unknown error";
            setMsg("Failed to load: " + err, true);
            return;
          }

          itemsCache = data.items || [];

          while (selectEl.firstChild) {
            selectEl.removeChild(selectEl.firstChild);
          }

          var opt0 = document.createElement("option");
          opt0.value = "";
          opt0.textContent = "-- Select saved info --";
          selectEl.appendChild(opt0);

          itemsCache.forEach(function (it) {
            var opt = document.createElement("option");
            opt.value = it.id || "";
            opt.textContent = it.label || it.shipping_address || "(no label)";
            selectEl.appendChild(opt);
          });

          if (!itemsCache.length) {
            setMsg("No saved addresses yet.", false);
          } else {
            setMsg("", false);
          }
        })
        .catch(function (err) {
          console.error("[ND AB] list error", err);
          setMsg("Failed to load addresses.", true);
        });
    }

    function loadById(id, showMessage) {
      if (!id) {
        if (showMessage) {
          setMsg("Please select an address first.", true);
        }
        return;
      }

      var item = itemsCache.find(function (it) {
        return String(it.id || "") === String(id);
      });

      console.log("[ND AB] loadById id =", id, "item =", item);

      if (!item) {
        if (showMessage) {
          setMsg("Saved info not found.", true);
        }
        return;
      }

      applyAddress(item);
      if (showMessage) {
        setMsg("Address loaded.", false);
      }
    }

    // Dropdown change -> auto load
    selectEl.addEventListener("change", function () {
      loadById(selectEl.value, false); // 不顯示「Please select～」訊息
    });

    // Save button (不包含 Reference Number)
    btnSave.addEventListener("click", function () {
      if (!customerEmail) {
        setMsg("Please sign in before saving.", true);
        return;
      }

      var label = window.prompt(
        "Name for this address (for example: Home / Office):",
        ""
      );
      if (label === null) return;
      label = String(label || "").trim();
      if (!label) {
        setMsg("Label is required.", true);
        return;
      }

      var fContact = root.querySelector('input[name="attributes[Shipping Contact Name]"]');
      var fPhone   = root.querySelector('input[name="attributes[Shipping Phone]"]');
      var fCompany = root.querySelector('input[name="attributes[Company Name]"]');
      var fAddress = root.querySelector('textarea[name="attributes[Shipping Address]"]');

      var params = {
        action: "saveAddress",
        key: apiKey,
        customer_email: customerEmail,
        label: label,
        contact_name:     fContact ? fContact.value : "",
        phone_number:     fPhone   ? fPhone.value   : "",
        company_name:     fCompany ? fCompany.value : "",
        shipping_address: fAddress ? fAddress.value : ""
        // Reference Number is intentionally NOT saved
      };

      setMsg("Saving address...", false);

      fetchJSON(params)
        .then(function (data) {
          console.log("[ND AB] saveAddress data =", data);

          if (!data || data.ok === false) {
            var err = (data && data.error) ? data.error : "Unknown error";
            setMsg("Save failed: " + err, true);
            return;
          }
          setMsg("Address saved.", false);
          reloadList();
        })
        .catch(function (err) {
          console.error("[ND AB] save error", err);
          setMsg("Save failed.", true);
        });
    });

    // Delete button (soft delete)
    btnDelete.addEventListener("click", function () {
      if (!customerEmail) {
        setMsg("Please sign in before deleting.", true);
        return;
      }

      var id = selectEl.value;
      if (!id) {
        setMsg("Please select an address to delete.", true);
        return;
      }

      var ok = window.confirm("Delete this address?");
      if (!ok) return;

      var params = {
        action: "deleteAddress",
        key: apiKey,
        customer_email: customerEmail,
        id: id
      };

      setMsg("Deleting address...", false);

      fetchJSON(params)
        .then(function (data) {
          console.log("[ND AB] deleteAddress data =", data);

          if (!data || data.ok === false) {
            var err = (data && data.error) ? data.error : "Unknown error";
            setMsg("Delete failed: " + err, true);
            return;
          }
          setMsg("Address deleted.", false);
          reloadList();
        })
        .catch(function (err) {
          console.error("[ND AB] delete error", err);
          setMsg("Delete failed.", true);
        });
    });

    // Clear Shipping Info button
    btnClear.addEventListener("click", function () {
      clearShippingFields();
    });

    // Initial load
    reloadList();
  }

  // ---------- Init on /cart page ----------

  function init() {
    if (!/\/cart(\/|$)/.test(location.pathname)) return;

    var form = getCartForm();
    if (!form) return;

    if (document.getElementById("nd-cart-shipping-fields")) return;

    var heading = Array.prototype.slice
      .call(form.querySelectorAll("h1,h2"))
      .find(function (el) {
        return /your cart/i.test(el.textContent || "");
      });

    var anchor = heading;
    if (heading) {
      var row = heading;
      while (row && row !== form) {
        if (/clear cart/i.test(row.textContent || "")) {
          anchor = row;
          break;
        }
        row = row.parentElement;
      }
    }

    var block = buildAddressBookAndShippingBlock();

    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(block, anchor.nextSibling);
    } else {
      form.insertBefore(block, form.firstChild);
    }

    setupAddressBook(block);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
